import { filterNonNull } from "@zennya/web-component-library/src/components/SegmentIO";
import axios from "axios";
import { anonFetchSchedules } from "./anon.service";
import isEmpty from "lodash.isempty";

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

const fetchBooking = async (codeId) => {
  return (await axios.get(`${API_URL}/api/1/bookings/${codeId}`))?.data;
};
const confirmBooking = async (codeId) => {
  return (await axios.post(`${API_URL}/api/1/bookings/${codeId}/confirm`))
    ?.data;
};

const cancelBooking = async (codeId, cancel_reason) => {
  const retData = (await axios.put(`${API_URL}/api/1/bookings/${codeId}/cancel`, {
    cancel_reason
  }))?.data;
  await new Promise(resolve => setTimeout(resolve, 2000));
  return retData;
};


const cancelAppointment = async (codeId, cancel_reason) => {
  return (await axios.put(`${API_URL}/api/1/appointments/${codeId}/cancel`, {
    cancel_reason
  }))?.data;
};

const getVerifiedSchedules = async (clientId, params) => {
  let result;

  try {
    result = await axios.post(
      `${API_URL}/api/1/clients/${clientId}/bookings/scheduled/verify`,
      params
    );
  } catch (error) {
    return ({
      code: error?.response?.data?.code,
      message: {
        en:
          error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details
      }
    })
  }

  return result?.data || result?.response?.data;
};

const verifyIfLocationSupported = async ({ 
  isAuthenticated,
  session_token, 
  user, 
  booking, 
  services, 
  packages,
  type
}) => {
  // await new Promise(resolve => setTimeout(resolve, 3000));
  let result;
  if (isEmpty([...services, ...packages])) return true
  const params = filterNonNull({
    lat: booking?.location?.latitude,
    lng: booking?.location?.longitude,
    location_id: booking?.location?.id,
    duration: 60,
    extended_package_items: services?.map(x => x?.id),
    extended_packages: packages?.map(x => x?.id),
    packages: null,
    type: type,
    should_check_for_payment: false,
    client_type: 'web',
    should_check_for_medical_id: false,
    should_check_high_availability: true,
    "white_label_customer": booking?.white_label_customer?.id,
  })
  try {
    if (isAuthenticated) {
      result = await axios.post(
        `${API_URL}/api/1/clients/${user?.client?.id || user?.user?.id}/bookings/scheduled/verify`,
        params
      );
    } else {
      result = await axios.post(
        `${API_URL}/api/2/bookings/scheduled/verify`,
        { ...params, session_token }
      );
    }
    return true
  } catch (error) {
    if (error?.response?.data?.code === 'INVALID_LOCATION') {
      return false
    }
    throw error;
  }
}

const updateWhitelabelBookingDate = async (bookingId, date_scheduled) => {
  return await axios.post(
    `${API_URL}/api/1/whitelabel/bookings/schedules/set`,
    { date_scheduled, requests: [bookingId] }
  );
};

const fetchWhitelabelDeadline = async (wlpid) => {
  return (await axios.get(`${API_URL}/api/1/whitelabel/${wlpid}/settings/bookings/deadline`))?.data;
}


const createNewBooking = async (clientId, params) => {
  return (await axios.post(
    `${API_URL}/api/1/clients/${clientId}/bookings/createSingle`,
    { ...params }
  ))?.data
}


const fetchState = async (clientId) => {
  return (await axios.get(`${API_URL}/api/1/clients/${clientId}/state`))?.data;
}

const endAppointment = async (appointmentId) => {
  return (await axios.put(`${API_URL}/api/1/appointments/${appointmentId}/end`, { client_type: 'web' }))?.data;
}


const getExtensions = async (appointmentId) => {
  return (await axios.get(`${API_URL}/api/2/appointments/${appointmentId}/extensions`))?.data;
}

const extendAppointment = async (appointmentId, duration) => {
  return (await axios.post(`${API_URL}/api/2/appointments/${appointmentId}/extend`, {
    duration,
    client_type: 'web'
  }))?.data;

}

const getCancelReasons = async () => {
  return (await axios.get(`${API_URL}/api/1/bookings/cancellations/reasons`, {
    params: {
      type: 'CLIENT'
    }
  }))?.data;
}

const getDeepLinkLogin = async (bookingId) => {
  return (await axios.get(`${API_URL}/api/1/whitelabel/bookings/results/link`, {
    params: {
      request_id: bookingId
    }
  }))?.data;

}
const listBookings = async (clientId, params) => {
  let url = `${API_URL}/api/1/clients/${clientId}/bookings`

  return (await axios.get(url, {
    params: {
      ...params,
      client_id: clientId
    }
  }))?.data;
}

export {
  listBookings,
  getCancelReasons,
  getExtensions,
  extendAppointment,
  endAppointment,
  fetchState,
  updateWhitelabelBookingDate,
  fetchWhitelabelDeadline,
  getVerifiedSchedules,
  fetchBooking,
  confirmBooking,
  cancelBooking,
  cancelAppointment,
  createNewBooking,
  verifyIfLocationSupported,
  getDeepLinkLogin
};
